enum LocalStorageKey {
  UserToken = "user-token"
}

export default LocalStorageKey
